<template>
  <main>
    <div class="main-container">
      <div class="row" >
        <div class="col s12 l10 offset-l1 card-panel">
          <div class="row center-align" style="margin-bottom: 0%;">
            <div class="page-title">
              <h3>Reciclado masivo ({{lineasPorReciclar.length}}) </h3>
            </div>


          </div>
          <a  v-if="lineasPorReciclar.length" class="waves-effect waves-light btn col offset-l9  red darken-3" @click="reciclar()" style="margin-bottom: 25px;"><i class="material-icons left">cancel</i> Reciclar Todas</a>
          <div
              class="col s10 offset-s1  "
          >

            <table
                class="responsive-table striped highlight "
                style="text-align-last: center"
            >
              <thead>
              <tr>
                <th>#</th>
                <th v-for="titulo in titulos">
                  <div>
                    {{ titulo.valor }}
                  </div>
                </th>
                <th>Reciclar</th>
                <th>Olvidar</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(fila, index) in lineasPorReciclar">
                <td>{{index +1}}</td>
                <td>{{ fila.icc }}</td>
                <td>{{ fila.dn }}</td>
                <td>{{ fila.monto}}</td>
                <td>{{ fila.lider == 0 ? "Sin Lider" : fila.lider }}</td>
                <td>{{ fila.cliente == 0 ? "Sin Cliente" : fila.cliente }}</td>
                <td>{{fila.compania }}</td>
                <td>{{ fila.username }}</td>
                <td>{{ fila.fecha_subida }}</td>
                <td>{{ fila.fecha_actualizacion }}</td>
                <td>{{ fila.vigencia }}</td>
                <td>{{ fila.fecha_recarga }}</td>
                <td><a class="waves-effect waves-light btn  blue-grey darken-3 " @click="reciclar(fila.dn)"><i class="material-icons left">rotate_left</i></a></td>
                <td><a class="waves-effect waves-light btn  red darken-3" @click="olvidar(fila.dn)"><i class="material-icons left">cancel</i></a></td>

              </tr>
              </tbody>
            </table>
          </div>


        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { i18n } from "../constantes";

import {mostrarPendientesDeReciclar, olvidarLineaReciclada, reciclarLineas} from "@/api/api";

export default {
  name: "recicladoMasivo",
  data() {
    return {
      titulos: [
        { llave: "icc", valor: "Icc" },
        { llave: "dn", valor: "DN" },
        { llave: "monto", valor: "Monto" },
        { llave: "lider", valor: "Lider" },
        { llave: "cliente", valor: "Cliente" },
        { llave: "compania", valor: "compañia" },
        { llave: "subidoPor", valor: "Subido por" },
        { llave: "fechaSubida", valor: "Subida" },
        { llave: "fechaActualizacion", valor: "Actualizada" },
        { llave: "fechaVigencia", valor: "Vigencia" },
        { llave: "fechaRecarga", valor: "Recarga" },

      ],
      lineasPorReciclar:[]
  }
  },
  mounted() {
    this.mostrarRecicladas();
  },
  methods: {
    mostrarRecicladas(){
      mostrarPendientesDeReciclar().then(r=>{
        console.log(r)
        this.lineasPorReciclar=r.data
      }).catch(e=>{
        console.log(e)
      })
    },
    olvidar(dn){
      let objetoaEnviar = {};
      objetoaEnviar.dnReciclar = dn;
      olvidarLineaReciclada(objetoaEnviar)
          .then((respuesta) => {
            M.toast({
              html: `Dn olvidada`,
              classes: "rounded",
              displayLength: 3000,
            });
            this.mostrarRecicladas()
          })
          .catch((error) => {
            console.log(error);
            M.toast({
              html: error.message,
              classes: "rounded",
              displayLength: 3000,
            });

          });
      this.dnReciclar = "";
    },
    reciclar(dn){
      let objetoaEnviar = {};
        if(dn==null) dn=this.lineasPorReciclar.map(r=>r.dn)

        objetoaEnviar.dnReciclar = dn;

        reciclarLineas(objetoaEnviar)
            .then((respuesta) => {
              M.toast({
                html: `Dn reciclados`,
                classes: "rounded",
                displayLength: 3000,
              });
              this.mostrarRecicladas()
            })
            .catch((error) => {
              console.log(error);
              M.toast({
                html: error.message,
                classes: "rounded",
                displayLength: 3000,
              });

            });
        this.dnReciclar = "";
      },
  },
};
</script>

<style scoped>
.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}
.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
  both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

.main-container {
  width: 94%;
  margin: 0 auto;
}
.col .row {
  margin-left: -0rem;
  margin-right: -0rem;
}

@media (max-width: 800px) {
  table {
    font-size: 0.8rem;
  }

  th {
    height: 63px;
    max-height: 63px;
  }
  td {
    height: 63px;
    max-height: 63px;
  }

  .titulo {
    font-size: 2rem;
  }
}
</style>
